import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import "./Filter.css";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const FilterSidebar = ({
  setSelectedFilter,
  selectedFilter,
  filters,
  appliedFilters,
}) => {
  const [selectedItem, setSelectedItem] = useState("");
  const handleItemClick = (filter) => {
    setSelectedItem(filter); // Update selectedItem when clicked
    setSelectedFilter(filter); // Notify parent component
  };

  return (
    <Box sx={{ width: "35%", backgroundColor: "#488257", height: "100vh" }}>
      <Typography variant="h5" sx={{ color: "white", mt: 1, p: 2 }}>
        Filter
      </Typography>
      <List sx={{ width: "100%" }}>
        {filters.map((filter) => {
          const resolvedKey = (() => {
            if (filter === "Vendor Name") return "LogisticVendor";
            return filter;
          })();

          return (
            <ListItem
              key={filter}
              button
              sx={{
                fontSize: "16px",
                mb: 1,
                backgroundColor: selectedItem === filter ? "#fff" : "inherit",
                color: selectedItem === filter ? "#488257" : "white",
                justifyContent: "space-between",
              }}
              onClick={() => handleItemClick(filter)}
              className={`list-item ${
                selectedItem === filter || selectedFilter === filter
                  ? "active"
                  : ""
              }`}
            >
              <ListItemText primary={filter} />

              {appliedFilters[resolvedKey] && (
                <ListItemIcon
                  sx={{
                    fontSize: "10px",
                    color: selectedFilter === filter ? "#488257" : "white",
                    minWidth: "auto",
                  }}
                >
                  <FiberManualRecordIcon
                    sx={{
                      fontSize: "10px",
                      "&:hover": { color: "#FFFFFF" },
                    }}
                  />
                </ListItemIcon>
              )}
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default FilterSidebar;
